import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PdfWrapperComponent } from './pdf-wrapper.component';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MyMaterialModule } from 'src/app/app.material';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
  imports: [
    CommonModule,
    MyMaterialModule,
    PdfViewerModule,
    FlexLayoutModule,
    FormsModule,
    MatIconModule,
    TranslocoModule
  ],
  declarations: [
    PdfWrapperComponent
  ],
  exports: [PdfWrapperComponent]

})
export class PdfWrapperModule {}
